/*!
=========================================================
* 敷金
=========================================================
*/
import React from "react";

import {
  Button,
  Row, Col,
  Label
} from "reactstrap";

import Request from '../../common/Request';
import InputSelect from '../FormParts/InputSelect'
import DialogBase from '../Base/DialogBase';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.14
import Format from '../../common/Format';
import Definition from '../../common/Definition';
import OptionConvert from '../../common/OptionConvert';

import InputText from '../FormParts/InputText';
import InputDatetime from '../FormParts/InputDatetime';
import InputCheckBox from '../FormParts/InputCheckBox';
import WithRole from '../FormParts/ButtonWithRole';
import CsvDownloader from "react-csv-downloader";

import {
  cst_security_deposit_contact_status,
  cst_security_deposit_status,
  cst_security_deposit_execute_list
} from '../../variables/codes_map';

import { GetMessage, getErrorCodes } from '../../variables/message';
import { SECURITY_DEPOSIT_LIST } from '../../variables/csv'
import { sortByNumber } from "../../common/Sort"

const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '見積ID',accessor: 'SECURITY_DEPOSIT__estimate_natural_id',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '仕入先',accessor: '___JOIN_security_deposit_supplier',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '連絡状況',accessor: '___JOIN_security_deposit_contact_status',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '回収状況',accessor: '___JOIN_security_deposit_status',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '契約終了日',accessor: 'SECURITY_DEPOSIT__quote_available_end_date',headerClassName:'text-center',className:'text-left text-top',width:180,minWidth:50},
    { Header: '敷金',accessor: '___CAL_security_deposit_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金合計額',accessor: 'SECURITY_DEPOSIT__security_deposit_collect_total_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '残額',accessor: 'SECURITY_DEPOSIT__security_deposit_uncollect_amt',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, sortMethod: sortByNumber },
    { Header: '入金履歴',accessor: 'actions_1',headerClassName:'text-center',className:'text-center',width:120,minWidth:50, sortable : false},
    { Header: '入金メモ',accessor: 'SECURITY_DEPOSIT__security_deposit_memo',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50, sortable : false},
    { Header: 'キャンセル',accessor: 'actions_2',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50, sortable : false},
    { Header: '最終更新情報',accessor: '___JOIN_security_deposit_update',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '敷金管理',
      add_url: '',
      //search_url: '/api/securitydeposit',
      search_url: '/api/securitydeposit/unlimit', // #1168-2021.7.14

      header_md:"3",

      REQUEST__request_natural_id: "",
      landmark_branch: "",
      SECURITY_DEPOSIT__refund_stat: "",
      actions_1: "",

      column: this.default_column,
      detail_search:false,
      show_detail_search_field:false,
      valid: true,
      all_checked: true,
      with_all_check: true,
      
      checkbox_field_in_table:true,
      searchData:{
        values:{
          security_deposit_status : ["0","1"],
          quote_available_end_date_to : moment().add(1, 'months').endOf('months').format("YYYY-MM-DDT00:00:00")
        },
        errors:{},
        requiredData:{}
      },
      executionData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      landmark_user:[],
      user_list_for_lastupdate:[],
      listCsvData : [],
      auto_scroll:true,
      unique_key:"SECURITY_DEPOSIT__estimate_natural_id",
    });

    this.dialogConfirm = React.createRef();
    this.dialogCsvDownload = React.createRef();
    this.dialogCancel = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.validateExecCallback = this.validateExecCallback.bind(this)
    this.onClickExecButton = this.onClickExecButton.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list_for_lastupdate = OptionConvert.optionsById(res.Data)
      const user_list = res.Data.map((user)=>{
        return {value:user.id, label:user.name}
      })
      this.setState({
        landmark_user:user_list,
        user_list_for_lastupdate
      }, () => {
        this.search()
      });
    })

    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  search = (refreshTaskFlag = false) => {
    /* #1168-2021.9.14 limit offsetの追加 */
    this.search_count();
    var search_param = this.search_params();
    search_param["pager_index"] = "0";
    search_param["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      search_param
      , res => {
        this.setState({
            data: this.dataMap(res.Data),
            paging: {
              "index": parseInt(search_param["pager_index"]),
              "limit": parseInt(search_param["pager_limit"])
            },  
            searched_data : res.Data
        });
    })

    // 未連絡件数取得
    const params = {
      security_deposit_contact_status : [0],
      no_contact_count_quote_available_end_date : moment().add(1, 'months').endOf('months').format("YYYY-MM-DDT00:00:00"),
      "data_count": 1
    }
    Request.get(this.state.search_url, params, res => {
        this.setState({
            noContactCount: res.Data,
        });
    })

    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.9.14 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        console.log(res.data);
        this.setState({data_count: res.Data});
    })
  }
  
  
  validateCallbackForMemo(newData, prop, key){
    this.setState({
      data : [
        ...this.state.data.slice(0, key),
        {
          ...this.state.data[key],
          SECURITY_DEPOSIT__security_deposit_memo : {
            ...this.state.data[key].SECURITY_DEPOSIT__security_deposit_memo,
            props : {
              ...this.state.data[key].SECURITY_DEPOSIT__security_deposit_memo.props,
              rootData : newData
            }
          }
        },
        ...this.state.data.slice(key+1),
      ]
    })
    if(Object.keys(newData.errors).length > 0){
      return;
    }
    const originMemo = this.state.data[key].SECURITY_DEPOSIT__security_deposit_memo.props.rootData.values.security_deposit_memo;
    if ( originMemo == newData.values.security_deposit_memo
      || (originMemo == null && newData.values.security_deposit_memo == "")) {
      return;
    }

    const params = {
      ...prop,
      security_deposit_memo : newData.values.security_deposit_memo
    }

    // update 入金メモ
    Request.put('/api/securitydeposit/update', params, res => {
      // this.search() // メモ更新時は再検索しない
    });
  }

  updateMemo(e, prop){
    const params = {
      ...prop,
      security_deposit_memo : e.target.value
    }

    // update 入金メモ
    Request.put('/api/securitydeposit/update', params, res => {
      this.search()
    });
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.user_list_for_lastupdate;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data) {
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}

      return {
        id: prop.id,
        ulid : prop.ulid,
        SECURITY_DEPOSIT__estimate_natural_id : prop.estimate_natural_id,
        ___JOIN_security_deposit_supplier : (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_security_deposit_supplier', prop)}} />),
        ___JOIN_security_deposit_contact_status : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_security_deposit_contact_status', prop)}} />,
        ___JOIN_security_deposit_status : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_security_deposit_status', prop)}} />,
        SECURITY_DEPOSIT__quote_available_end_date : Format.format_date(prop.quote_available_end_date),
        ___CAL_security_deposit_amt : Format.comma_delimited(prop.quote_cost_security_deposit_total_amt + prop.add_cost_security_deposit_amt, "円"),
        SECURITY_DEPOSIT__security_deposit_collect_total_amt : Format.comma_delimited(prop.security_deposit_collect_total_amt, "円"),
        SECURITY_DEPOSIT__security_deposit_uncollect_amt : Format.comma_delimited(prop.security_deposit_uncollect_amt, "円"),
        checked:( this.checkedForItem(prop) )? true: undefined,
        actions_1 : 
          <>
            <ButtonWithRole 
              button_id={"BTN_J1_01_04910"}
              size="sm"
              onClick={() => {this.props.history.push(`/securitydeposit/${prop.ulid}`)}}
            >
              入金履歴
            </ButtonWithRole>
          </>
        ,
        SECURITY_DEPOSIT__security_deposit_memo : (
          <InputText
            key={prop.estimate_natural_id}
            label='入金メモ'
            name='SECURITY_DEPOSIT__security_deposit_memo'
            labelOn={false}
            multiline={true}
            validateCallback={(newData) => this.validateCallbackForMemo(newData, prop, key)}
            validateType={'regist'}
            rootData={{
              values : {
                security_deposit_memo : prop.security_deposit_memo
              },
              errors : {},
              requiredData : {}
            }}
          />
        ),
        actions_2 : 
        <>
          <ButtonWithRole 
            button_id={"BTN_J1_01_04911"}
            size="sm"
            disabled={prop.security_deposit_cancel_status == 1 || prop.security_deposit_status == 2}
            onClick={() => {
              this.setState({
                dialogData : prop
              }, () => {
                this.dialogCancel.current.show();
              })
            }}
          >
            キャンセル
          </ButtonWithRole>
          {Format.format_datetime(prop.security_deposit_cancel_date)}
        </>
      ,
        ___JOIN_security_deposit_update : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_security_deposit_update', prop_tmp)}} />,
        update_timestamp : prop.update_timestamp
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  validateExecCallback(newData, callback=()=>{}){
    this.setState({
      executionData:{
        ...this.state.executionData,
        ...newData
      }
    }, ()=>callback())
  }

  onClickExecButton() {
//    const checked_items = this.state.data.filter((item) => item.checked)
  var checked_items = this.state.checkedItems;
  if (checked_items.length<1) {
      return
    }

    const exec_action = this.state.executionData.values.exec_action;
    if(exec_action === undefined){
      return
    }
    const dialogTitle = exec_action == 0 ? "未連絡" : exec_action == 1 ? "1ヶ月前連絡済" : "当月連絡済";
    this.setState({
      dialogTitle : dialogTitle,
      contactStatus : this.state.executionData.values.exec_action ,
      checkedData: checked_items,
    }, ()=>{
      this.allStateClear();
      this.dialogConfirm.current.show();
    })
  }

  search_field_cols() {
    return (
      <>
      <Col md="3">
          <InputText
            label='見積ID'
            name='SECURITY_DEPOSIT__estimate_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='仕入先名'
            name='SUPPLIER__supplier_name'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='仕入先TEL'
            name='SUPPLIER__supplier_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputSelect label="ランドマーク支店"
            name="USER_BRANCH__user_branch_natural_id"
            labelOn={true} 
            validateCallback={this.validateCallback} 
            options={this.state.landmark_user_branch}
            enterSearch={true}
            enterCallback={this.searchWithPageIndex}
            rootData={this.state.searchData} />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約終了日（FROM）'
            name='SECURITY_DEPOSIT__quote_available_end_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='契約終了日（TO）'
            name='SECURITY_DEPOSIT__quote_available_end_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='回収完了日（FROM）'
            name='SECURITY_DEPOSIT__security_deposit_collect_finish_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputDatetime
            label='回収完了日（TO）'
            name='SECURITY_DEPOSIT__security_deposit_collect_finish_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputCheckBox
            label='回収状況'
            name='SECURITY_DEPOSIT__security_deposit_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_security_deposit_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputCheckBox
            label='連絡状況'
            name='SECURITY_DEPOSIT__security_deposit_contact_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_security_deposit_contact_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputCheckBox
            label='キャンセルも表示する'
            name='SECURITY_DEPOSIT__security_deposit_cancel_status'
            labelOn={false}
            checkedValue={1}
            uncheckedValue={0}
            validateCallback={this.validateCallback}
            rootData={this.state.searchData}
          />
        </Col>

        
      </>
    );
  }
  add_field_cols() {
    const {
      noContactCount,
    } = this.state
    return (
	<>
    <Col md="6"></Col>
    <Col md="3">
      <div style={{paddingTop: "35px"}}>未連絡件数：{noContactCount}</div>
    </Col>
	</>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<></>);
  }
  getButtonIdByExecutionType(executionType) {
    switch(executionType){
      case "1ヶ月前連絡済":
      return "BTN_J1_01_04860"
      case "当月連絡済":
      return "BTN_J1_01_04870"
      case "未連絡":
      return "BTN_J1_01_04880"
      default:
      return undefined
    }
  }

  checkbox_field_cols(){
    const buttonIdByExecutionType = this.getButtonIdByExecutionType(this.state.executionData.values.exec_action)
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
      <>
        <Col md='3'><Label for="" className="search-text-order">チェックした敷金を</Label>
          <InputSelect
            label='処理'
            name='TEMP__exec_action'
            options={cst_security_deposit_execute_list}
            rootData={this.state.executionData}
            validateCallback={this.validateExecCallback} 
          />
        </Col>
        <Col md='3'>
          <ButtonWithRole 
            button_id={buttonIdByExecutionType}
            onClick={this.onClickExecButton}
            className="float-right"
          >
            実行
          </ButtonWithRole>
        </Col>
        <Col md='3'>
        <ButtonWithRole 
            button_id={"BTN_J1_01_04890"}
            onClick={() => {
              this.setState({
                dialogTitle : "一覧CSV出力",
              }, () => {
                this.dialogCsvDownload.current.show()
              })
            }}
            className="float-right"
          >
            一覧CSV出力
          </ButtonWithRole>
        </Col>
        <Col md='3'>
          <ButtonWithRole 
            button_id={"BTN_J1_01_04900"}
            onClick={() => {
              this.setState({
                dialogTitle : "入金履歴CSV出力"
              }, () => {
                this.dialogCsvDownload.current.show()
              })
            }}
            className="float-right"
          >
            入金履歴CSV出力
          </ButtonWithRole>
        </Col>
      </>
    );
  }
  dialog_defines() {
    return (
      <>
        <DialogConfirm 
          ref={this.dialogConfirm} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          checkedData={this.state.checkedData}
          contactStatus={this.state.contactStatus}
          positive={true}
          refreshCallback={this.search}
        />
        <DialogCsvDownload
          ref={this.dialogCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          user_list = {this.state.user_list_for_lastupdate}
          searched_data = {this.state.searched_data}
          search_params = {() => this.search_params()}
          positive={true}
          default_footer={true}
        />
        <DialogCancel
          ref={this.dialogCancel} 
          {...this.props}
          dialogData={this.state.dialogData}
          positive={true}
          refreshCallback={this.search}
        />
      </>
    );
  }    
}

export default List;

export class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      dialogData : {
        ...this.state.dialogData,
        requiredData:{
          security_deposit_prepare_contact_date:[GetMessage(2024)],
          security_deposit_contact_date:[GetMessage(2024)],
        },
        errors : {}
      }
    }

    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title:"チェックした敷金について"+this.props.dialogTitle+'にします。よろしいですか？',
        dialogData : {
          ...this.state.dialogData,
          values : {
            security_deposit_prepare_contact_date : this.props.contactStatus == 1 ? moment().format("YYYY-MM-DDT00:00:00") : undefined,
            security_deposit_contact_date : this.props.contactStatus == 2 ? moment().format("YYYY-MM-DDT00:00:00") : undefined,
          },
          errors : {}
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  handleClickPositive() {
    const {
      security_deposit_prepare_contact_date,
      security_deposit_contact_date
    } = this.state.dialogData.values

    if(!this.validate()){
      return;
    }

    const params = {
      security_deposit_contact_status : this.props.contactStatus,
      checkedData : this.props.checkedData,
      security_deposit_prepare_contact_date : this.props.contactStatus == 1 ? security_deposit_prepare_contact_date : undefined,
      security_deposit_contact_date : this.props.contactStatus == 2 ? security_deposit_contact_date : undefined,
    }
    Request.put("/api/securitydeposit/update", params , res => {
      this.props.refreshCallback();
      this.toggleModal();
    });
  }

  bodyContent() {
    return (
      <>
        {this.props.contactStatus == 1 &&
          <Row>
            <Col md="12">
              <InputDatetime
                label='1ヶ月前連絡日'
                name='SECURITY_DEPOSIT__security_deposit_prepare_contact_date'
                labelOn={true}
                validateCallback={this.validateCallback}
                rootData={this.state.dialogData}
                validateType={'regist'}
              />
            </Col>
          </Row>
        }
        {this.props.contactStatus == 2 &&
          <Row>
            <Col md="12">
              <InputDatetime
                label='当月連絡日'
                name='SECURITY_DEPOSIT__security_deposit_contact_date'
                labelOn={true}
                validateCallback={this.validateCallback}
                rootData={this.state.dialogData}
                validateType={'regist'}
              />
            </Col>
          </Row>
        }
      </>
    );
  }
}

export class DialogCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.getListCsv = this.getListCsv.bind(this)
    this.getDetailCsv = this.getDetailCsv.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
        user_list : this.props.user_list,
        dialogData : {
          values : {
            security_deposit_collect_date_from : moment().add(-7, "days").format("YYYY-MM-DDT00:00:00"),
            security_deposit_collect_date_to : moment().format("YYYY-MM-DDT23:59:59"),
          },
          errors: {
            ...this.state.dialogData.errors
          }, 
          requiredData :{
            security_deposit_collect_date_from:[GetMessage(2024)],
            security_deposit_collect_date_to:[GetMessage(2024)],
          }
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  async getListCsv(){
    const search_params = {
      ...this.props.search_params()
    }
    const searched_data = await new Promise((resolve, reject)=> {
      Request.get(`/api/securitydeposit/csv`, search_params , res => {
        resolve(res.Data)
      })
    })

    const distinctdeposit = searched_data.filter((detail, index, self) =>
      index === self.findIndex((t) => (
        t.id === detail.id
      ))
    )
    const csvData = this.makeCsv(distinctdeposit, searched_data)
    return csvData
  }

  getDetailCsv() {
    const params = {
      security_deposit_collect_date_from : this.state.dialogData.values.security_deposit_collect_date_from,
      security_deposit_collect_date_to : this.state.dialogData.values.security_deposit_collect_date_to,
      security_deposit_collect_user_id : this.state.dialogData.values.security_deposit_collect_user_id,
    }
    return new Promise(async (resolve, reject) => {
      const security_deposit = await new Promise((resolve, reject)=> {
        Request.get(`/api/securitydeposit/csv`, params , res => {
          resolve(res.Data)
        })
      })

      const distinctdeposit = security_deposit.filter((detail, index, self) =>
        index === self.findIndex((t) => (
          t.security_deposit_id === detail.security_deposit_id
        ))
      )
      const csvData = this.makeCsv(distinctdeposit, security_deposit)
      resolve(csvData)
    })
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  makeCsv(security_deposit, detailsList){
    const csvData = security_deposit.reduce((acc, data) => {
      const updateUser = this.props.user_list.find((user) => user.id === data.lastupdate_user_id)

      const details = detailsList.filter((detail)=> {
        return detail.id === data.id
      })

      let detailCsv = []
      for(let i=0; i<10; i++){
        const detail = details[i];
        
        if(detail){
          const detailUpdateUser = this.props.user_list.find((user) => user.id === detail.security_deposit_collect_user_id)
          detailCsv = detailCsv.concat([
            this.isNullOrUndefined(detail.security_deposit_collect_date) ?  "" : moment(detail.security_deposit_collect_date).format("YYYY/MM/DD"),
            this.isNullOrUndefined(detail.security_deposit_collect_amt) ? "" : detail.security_deposit_collect_amt,
            this.isNullOrUndefined(detail.security_deposit_collect_type) ? "" : detail.security_deposit_collect_type,
            detailUpdateUser ? detailUpdateUser.label : "",
          ])
        } else {
          detailCsv = detailCsv.concat([
            "",
            "",
            "",
            "",
          ])
        }
      }
      acc.push([
        this.isNullOrUndefined(data.estimate_natural_id) ? "" : data.estimate_natural_id,
        this.isNullOrUndefined(data.survey_parking_name) ? "" : data.survey_parking_name,
        this.isNullOrUndefined(data.supplier_name) ? "" : data.supplier_name,
        this.isNullOrUndefined(data.supplier_tel) ? "" : data.supplier_tel,
        this.isNullOrUndefined(data.supplier_fax) ? "" : data.supplier_fax,
        this.isNullOrUndefined(data.security_deposit_contact_status) ? "" : data.security_deposit_contact_status,
        this.isNullOrUndefined(data.security_deposit_prepare_contact_date) ? "" : moment(data.security_deposit_prepare_contact_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.security_deposit_contact_date) ? "" : moment(data.security_deposit_contact_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.security_deposit_status) ? "" : data.security_deposit_status,
        this.isNullOrUndefined(data.security_deposit_collect_finish_date) ? "" : moment(data.security_deposit_collect_finish_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.quote_cost_security_deposit_total_amt) ? "" : ((data.quote_cost_security_deposit_total_amt || 0) + (data.add_cost_security_deposit_amt || 0)),
        this.isNullOrUndefined(data.security_deposit_collect_total_amt) ? "" : data.security_deposit_collect_total_amt,
        this.isNullOrUndefined(data.security_deposit_uncollect_amt) ? "" : data.security_deposit_uncollect_amt,
        updateUser ? updateUser.label : "",
        ...detailCsv
      ])
      return acc
    }, [[...SECURITY_DEPOSIT_LIST.HEADER]])

    return this.wrappingQuote(csvData);
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      this.props.dialogTitle === "入金履歴CSV出力" ? 
      <>
        <Row>
          <Col md="6">
            <InputDatetime
              label='入金日（FROM）'
              name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
          <Col md="6">
            <InputDatetime
              label='入金日（TO）'
              name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              validateType={'search'}
            />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <InputSelect
              label='入金履歴登録者'
              name='SECURITY_DEPOSIT_DETAIL__security_deposit_collect_user_id'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.dialogData}
              options={this.state.user_list}
              validateType={'search'}
              isSearchable={true}
            />
          </Col>
        </Row>
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }
            const csvData = await this.getDetailCsv();
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`security_deposit_collect_history_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
      :
      <> 
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            const csvData = await this.getListCsv();
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`security_deposit_list_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogCancel extends DialogBase {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      dialogData:this.props.dialogData
    }

    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogData !== this.props.dialogData || prevState.modal !== this.state.modal){
      // console.log(this.props.dialogData)
      this.setState({
        title:this.props.dialogData.estimate_natural_id + "をキャンセルします。よろしいですか？",
        dialogData : {
          ...this.props.dialogData,
          values : {
            ...this.props.dialogData,
            security_deposit_cancel_status : 1,
            security_deposit_cancel_date : moment().format("YYYY-MM-DDTHH:mm:ss") ,
          },
          errors : {}
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  handleClickPositive() {
    const {
      security_deposit_cancel_status,
      security_deposit_cancel_date,
    } = this.state.dialogData.values

    if(!this.validate()){
      return;
    }

    const params = {
      ...this.state.dialogData.values,
      security_deposit_cancel_status ,
      security_deposit_cancel_date,
    }
    Request.put("/api/securitydeposit/update", params , res => {
      this.props.refreshCallback();
      this.toggleModal();
    });
  }

  bodyContent() {
    return (
      <>
        {this.props.contactStatus == 1 &&
          <Row>
            <Col md="12">
              <InputDatetime
                label='1ヶ月前連絡日'
                name='SECURITY_DEPOSIT__security_deposit_prepare_contact_date'
                labelOn={true}
                validateCallback={this.validateCallback}
                rootData={this.state.dialogData}
                validateType={'regist'}
              />
            </Col>
          </Row>
        }
        {this.props.contactStatus == 2 &&
          <Row>
            <Col md="12">
              <InputDatetime
                label='当月連絡日'
                name='SECURITY_DEPOSIT__security_deposit_contact_date'
                labelOn={true}
                validateCallback={this.validateCallback}
                rootData={this.state.dialogData}
                validateType={'regist'}
              />
            </Col>
          </Row>
        }
      </>
    );
  }
}